import { render, staticRenderFns } from "./YlJGItem.vue?vue&type=template&id=d772d94e&scoped=true&"
import script from "./YlJGItem.vue?vue&type=script&lang=ts&"
export * from "./YlJGItem.vue?vue&type=script&lang=ts&"
import style0 from "./YlJGItem.vue?vue&type=style&index=0&id=d772d94e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d772d94e",
  null
  
)

export default component.exports